import React, { Ref } from "react";

import { IFieldType } from "shared/types";
import { FieldWrapper, FieldWrapperProps } from "./FieldWrapper";
import { InputFieldWrapper, Suffix, StyledInputField } from "./styles";

export interface InputFieldProps extends FieldWrapperProps {
  registerRef?: Ref<HTMLInputElement>;
  placeholder?: string;
  value?: string | number | null;
  type?: IFieldType.text | IFieldType.email | IFieldType.password | IFieldType.website;
  disabled?: boolean;
  readOnly?: boolean;
  autocomplete?: string;
  onChange?: (e: any, prev?: any) => void;
  onBlur?: () => void;
  onClick?: () => void;
  suffix?: string | JSX.Element;
  maxLength?: number;
  autoFocus?: boolean;
  defaultValue?: any;
  hasError?: boolean;
}

export const InputField: React.FC<InputFieldProps> = ({
  registerRef,
  name,
  placeholder,
  value,
  type = "text",
  required,
  disabled,
  readOnly,
  autocomplete,
  onChange,
  onClick,
  onBlur,
  error,
  suffix,
  children,
  maxLength,
  autoFocus,
  defaultValue,
  hasError,
  tabIndex,
  ...rest
}) => {
  return (
    <FieldWrapper name={name} required={required} error={error} {...rest}>
      <InputFieldWrapper isDisabled={disabled} isReadOnly={readOnly} error={hasError || !!error}>
        <StyledInputField
          defaultValue={defaultValue}
          id={name}
          name={name}
          type={type}
          placeholder={placeholder}
          ref={registerRef}
          onChange={onChange}
          onClick={onClick}
          onBlur={onBlur}
          value={value ?? undefined}
          disabled={disabled}
          autoComplete={autocomplete}
          aria-required={required}
          maxLength={maxLength}
          readOnly={readOnly}
          autoFocus={autoFocus}
          tabIndex={tabIndex}
        />
        {suffix && <Suffix>{suffix}</Suffix>}
      </InputFieldWrapper>
    </FieldWrapper>
  );
};
